import {createContext, useContext, type ReactNode} from 'react'

const EmbeddedContext = createContext(false)

export function EmbeddedProvider({children}: {children: ReactNode}) {
    return <EmbeddedContext.Provider value={true}>{children}</EmbeddedContext.Provider>
}

export function useIsEmbedded(): boolean {
    return useContext(EmbeddedContext)
}
